import { API } from "@/lib/api";

// Streams an OpenAI-compatible chat completion. Calls onDelta(text) for each token.
export async function streamChat({ model, system, messages, signal, onDelta }) {
  const res = await fetch(`${API}/v1/chat/completions`, {
    method: "POST",
    credentials: "include",
    signal,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ model, stream: true, system: system || undefined, messages }),
  });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    const err = new Error(j.detail || "Échec de la génération");
    err.status = res.status;
    throw err;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop() || "";
    for (const p of parts) {
      const line = p.replace(/^data:\s?/, "").trim();
      if (!line || line === "[DONE]") continue;
      let obj;
      try { obj = JSON.parse(line); } catch { continue; }
      const delta = obj.choices?.[0]?.delta?.content;
      if (delta) onDelta(delta);
      if (obj.error) throw new Error(obj.error.message || "Erreur de génération");
    }
  }
}
